import { useSelector } from 'react-redux';
import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import type { SalesCheckinRootState } from '../common/types/SalesCheckinRootState';
import type { SalesCheckinAppState } from '../common/types/SalesCheckinAppState';

export const getPdfShareLinkUrl = (state: SalesCheckinRootState): string =>
    (state.salesCheckin as SalesCheckinAppState).pdfShareLink?.shortUrl ?? '';

/**
 * `shortUrl` cached from the most recent successful share-click, along with the
 * dealPdfVersion it was minted for — a mismatch against the current version means
 * the cache is stale and the link must be re-minted.
 */
export const getPdfShareLinkCache = (state: SalesCheckinRootState): { shortUrl?: string; cachedForVersion?: string } => {
    const pdfShareLink = (state.salesCheckin as SalesCheckinAppState).pdfShareLink;
    return { shortUrl: pdfShareLink?.shortUrl, cachedForVersion: pdfShareLink?.cachedForVersion };
};

export const getPdfShareLinkRequestStatus = (state: SalesCheckinRootState): ApiRequestStatus =>
    (state.salesCheckin as SalesCheckinAppState).pdfShareLink?.requestStatus ?? ApiRequestStatus.Idle;

export const usePdfShareLinkUrlSelector = (): string => useSelector(getPdfShareLinkUrl);

export const usePdfShareLinkRequestStatusSelector = (): ApiRequestStatus => useSelector(getPdfShareLinkRequestStatus);
